<template>
	<v-layout row wrap>

		<v-flex d-flex xs12>
			<v-card color="primary" dark>
				<v-card-text>
					<h2>{{numberOfModules > 1 ? 'Budżet modułu ' + moduleNumber : 'Budżet'}}</h2>
				</v-card-text>
			</v-card>
		</v-flex>


	</v-layout>
</template>
<script>
	export default {
		name: "CostsMainTitle",
		props:{
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
		}
	};
</script>
